import axios from 'axios';

// Secure Localhost Connection
//const baseURL = "https://10.10.10.89:5001";

const baseURL = "https://corrections.co.trumbull.oh.us/PublicAPI"

//Production version
// const baseURL = "https://localhost:5353/api"
// const baseURL = "https://10.10.10.85:5353/api"

//Guernsey old IIS machine (testing machine) connection:
//VUE_APP_APICONNECTIONSTRING=http://172.16.11.6:8080/api

//Guernsey current IIS machine connection:
//VUE_APP_APICONNECTIONSTRING=http://172.16.11.254:80/api

//const baseURL = process.env.VUE_APP_APICONNECTIONSTRING;

let APIKey = "90238vb09Bradjikh9v8werv398";

export default {

    // fetchBookingData() {
    //     return axios.get(`${baseURL}/${APIKey}/`, {
    //         headers: {
    //             'Access-Control-Allow-Origin': '*',
    //         }
    //     });
    // },

    // fetchDropDowns() {
    //     return axios.get(`${baseURL}/dropdowns/${APIKey}/`, {
    //         headers: {
    //             'Access-Control-Allow-Origin': '*',
    //         }
    //     })
    // },

    fetchCurrentBookingData() {
        return axios.get(`${baseURL}/current/${APIKey}/`)
    },

    fetchBookingData() {
        return axios.get(`${baseURL}/${APIKey}/`);
    },

    fetchDropDowns() {
        return axios.get(`${baseURL}/dropdowns/${APIKey}/`)
    },
    apiHealthCheck() {
        return axios.get(`${baseURL}/ping`);
    },

    fetchHistoricBookingData(searchTerms) {
        return axios.post(`${baseURL}/historic/${APIKey}/`,
            searchTerms
        )
    },

    fetchInmatePhotoData(inmateId, bookingId) {
        return axios.post(`${baseURL}/inmatePhotoBooking/${APIKey}/`,
            inmateId, bookingId
        )
    }
}